import { useEffect, useState } from 'react';
import axios from 'axios';
const qs = require('qs');

export default function useDealPipelineReport({ teamId, query, refreshKey = 0, enabled = true, totalsOnly = false }) {
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const queryKey = JSON.stringify(query || {});

  useEffect(() => {
    if (!teamId || !enabled) return undefined;

    let ignore = false;
    setLoading(true);
    setError(null);

    const params = Object.keys(query || {}).length > 0 ? { q: query } : {};
    if (totalsOnly) params.totals_only = true;
    axios.get(`/teams/${teamId}/crm/deal_pipeline_report.json`, {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: 'brackets' }),
    }).then((response) => {
      if (!ignore) setReport(response.data || null);
    }).catch(() => {
      if (ignore) return;
      setReport(null);
      setError('Failed to load the pipeline report');
    }).finally(() => {
      if (!ignore) setLoading(false);
    });

    return () => { ignore = true; };
  }, [teamId, queryKey, refreshKey, enabled, totalsOnly]);

  return { report, loading, error };
}
